import { render, staticRenderFns } from "./suplidosMX.vue?vue&type=template&id=57a9f614"
import script from "./suplidosMX.vue?vue&type=script&lang=js"
export * from "./suplidosMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports